<template>
  <div class="privacy">
    <h1>IZJAVA O ZASEBNOSTI</h1>
    <h2>Izjava o zasebnosti</h2>
    <p>
      V Hriberšek storitve, trgovina, tehnično svetovanje, Mitja Krajnc s.p. (v nadaljevanju: »Hriberšek Mitja Krajnc s.p.« ali »upravljavec osebnih podatkov«)
      cenimo vašo zasebnost, zato stremimo k najvišji stopnji varstva vaših
      osebnih podatkov. Pri nudenju naših storitev spletne platforme
      expar-store.com ali pri poslovanju preko telekomunikacijskih sredstev
      vam zagotavljamo, da vaše podatke obdelujemo skladno z veljavno evropsko
      zakonodajo (Splošno uredbo o varstvu podatkov) in skladno z nacionalno
      zakonodajo Republike Slovenije (vsakokrat veljavni zakon o varstvu osebnih
      podatkov, Zakon o elektronskih komunikacijah in Zakon o elektronskem
      poslovanju na trgu). <br />
      <br />
      Namen te Izjave o zasebnosti (v nadaljevanju: »Izjava«) je, da vas
      seznanimo s tem, za katere namene bodo vaši osebni podatki pridobljeni in
      kako se bodo uporabljali ter kakšne so vaše pravice v zvezi s podatki, ki
      jih hranimo o vas, ter kako jih uveljavljati. <br />
      <br />Pri Hriberšek Mitja Krajnc s.p. se zavezujemo, da bodo zbrani osebni podatki, ki jih boste
      posredovali preko naših spletnih strani ali preko telekomunikacijskih
      sredstev (npr. v sklopu elektronske korespondence), uporabljeni v skladu s
      to Izjavo, da vaših osebnih podatkov ne bomo prodajali, posojali ali
      kakorkoli drugače posredovali tretjim osebam, razen v zakonsko določenih
      primerih.
    </p>
    <h2>Upravljavec podatkov</h2>
    <p>
      Upravljavec vaših osebnih podatkov je Hriberšek Mitja Krajnc s.p., naslov: Šmartno v Rožni dolini 21A, 3201 Šmartno v Rožni dolini, elektronski naslov: mitja.krajnc@expar-store.com, telefonska
      številka: +386 41 763 005. <br /><br />
      Za vse teme in vsebine, ki bodo obravnavane s strani odgovorne osebe za
      varstvo podatkov, velja stroga zaupnost.
    </p>
    <h2>Osebni podatki</h2>
    <p>
      Osebni podatek je katerakoli informacija, ki vas identificira kot
      določenega ali določljivega posameznika. Posameznik je določljiv takrat,
      ko ga je mogoče neposredno ali posredno določiti, zlasti z navedbo
      identifikatorja kot je ime, identifikacijska številka, podatki o lokaciji,
      spletni identifikator ali z navedbo enega ali več dejavnikov, ki so
      značilni za posameznikovo fizično, fiziološko, genetsko, duševno,
      gospodarsko, kulturno ali družbeno identiteto. <br /><br />
      Ponudnik, skladno z nameni, opredeljenimi v nadaljevanju te Izjave, zbira
      in obdeluje naslednje osebne podatke:
    </p>
    <ul>
      <li>
        kontaktni podatki in podatki o vaši komunikaciji z upravljavcem (ime in
        priimek, delovno, domači naslov, elektronski naslov, telefonska
        številka, podatki o starosti in spolu, podatki ali je rezervacija
        opravljana kot družina, posameznik, par ali prijatelji, kadar je
        potrebno podatki o potnih listinah (identifikacijsko številko,
        državljanstvo, datum poteka veljavnosti in državo izdaje), podatki o
        vrsti plačilnega sredstva in morebitni drugi podatki o plačilu, v
        kolikor je potrebno, datum, ura in vsebina poštne ali elektronske
        komunikacije);
      </li>
      <li>
        zgodovina povpraševanj, nakupov darilnih bonov in rezervacij ter
        informacije o morebitnih dodatnih storitvah, kot so zavarovanja,
        parkirišča in podobno;
      </li>
      <li>
        podatke o uporabnikih spletnih strani upravljavca (IP naslov, datumi,
        ure in trajanje obiskov spletnih strani, podatki o lokaciji oz. vstopni
        točki dostopa do interneta, podatki o obiskanih podstraneh, podatki o
        opravljenih nastavitvah, idr.);
      </li>
      <li>
        podatke o registriranih oz. prijavljenih uporabnikih (elektronski
        naslov, geslo in ostale podatke in nakupih);
      </li>
      <li>
        podatke o registriranih ali neregistriranih kupcih storitev (vnosi v
        nakupovalno košarico, ime in priimek, naslov prebivališča, elektronski
        naslov, telefonska številka, naslov za dostavo darilnih bonov ali
        vaučerjev, kontaktni podatki za dostavo in telefonska številka, način
        prevzema in dostave, način plačila);
      </li>
      <li>
        podatke o uporabnikovih nakupih in izdanih računih (datum in kraj
        nakupa, kupljeni storitve, cene kupljenih storitev, skupni znesek
        nakupa, način plačila, naslov za dostavo, številka in datum izdaje
        računa, oznaka osebe, ki je izdala račun, ipd.) ter podatke o reševanju
        reklamacij izdelkov;
      </li>
      <li>
        podatke o vnosih v spletne obrazce (npr. v okviru nagradnih iger,
        prijave na e-listo ali vrsta oziroma področje zanimanja za prejemanje
        oglaševalskih sporočil);
      </li>
      <li>
        podatke kandidatov za zaposlitev glede prijave na delovna mesta (osebni
        podatki kot so ime, priimek, spol, datum in kraj rojstva, naslov,
        kontaktni podatki kot so elektronski naslov in telefonska številka,
        podatki navedeni v motivacijskem pismu in življenjepisu kot so podatki o
        izobrazbi, preteklih delovnih izkušnjah, kompetencah in sposobnostih,
        izobraževanjih in tečajih idr.);
      </li>
      <li>
        druge podatke, ki jih uporabniki prostovoljno podajo upravljavcu ob
        naročilu določene storitve ali posredovanju ponudbe oziroma
        povpraševanja;
      </li>
      <li>
        sporočila, ki jih izmenjujete z nami, ali nam jih pošljete preko SMS,
        e-poštnih sporočil, klepetalnic, telefonskih klicev in socialnih
        medijev.
      </li>
    </ul>
    <p>
      Upravljavec ne zbira in ne obdeluje vaših osebnih podatkov, razen kadar mu
      vi to omogočite oz. v to privolite, tj. ob naročilu storitev in izdelkov,
      ko se naročite na prejemanje akcij in novosti preko naše e-liste,
      sodelujete v nagradni igri itd., ali kadar za zbiranje osebnih podatkov
      obstaja zakonska podlaga ali imamo za obdelavo vaših podatkov zakonite
      interese.
    </p>
    <h2>Namen obdelave podatkov in pravne podlage</h2>
    <p>
      Vsi osebni podatki, ki nam jih posredujete, bodo obravnavani zaupno in
      bodo uporabljeni zgolj v namene, za katere so bili posredovani in zbrani.
      Če bo nastala potreba po nadaljnji obdelavi vaših podatkov za drug namen,
      vas bomo predhodno kontaktirali in zaprosili za vašo predhodno pisno
      privolitev.
    </p>
    <h2>Obisk spletne strani expar-store.com</h2>
    <p>
      Ob vsakem obisku naših spletnih strani se na spletnem strežniku avtomatsko
      shranjuje dnevniška datoteka spletnega strežnika. Tako zbrane (osebne)
      podatke zbiramo s pomočjo piškotkov, pri čemer vas bomo pred namestitvijo
      bolj invazivnih piškotkov vprašali za vašo privolitev, medtem ko lahko
      določene druge podatke zbiramo že na podlagi naših zakonitih interesov.

      <br /><br />Tako zbrane (osebne) podatke obdelujemo posebej in jih ne
      povezujemo z drugimi osebnimi podatki uporabnikov naših spletnih strani
      ter ne izvajamo nobenega profiliranja vašega nakupnega vedenja.
    </p>
    <h2>Oprava nakupa storitev</h2>
    <p>
      Vaše osebne podatke obdelujemo zlasti v primeru, če kot registriran ali
      neregistriran uporabnik naše spletne strani expar-store.com kupite
      določene storitve. Te podatke obdelujemo izključno za namene izpolnjevanja
      naših pogodbenih obveznosti ter uveljavljanja pravic iz pogodbenega
      razmerja, vključno z reševanjem reklamacijskih izdelkov.
      <br /><br />Osebne podatke, ki nam jih posredujete za namen dostave
      izdelkov, obdelujemo izključno za namene dostave izdelkov na vaš naslov.
      Ti vaši osebnih podatki (npr. ime in priimek, naslov dostave, telefonska
      številka) se lahko posredujejo ponudnikom prevoza blaga. <br /><br />
      Naše kupce lahko na podlagi Zakona o elektronskih komunikacijah na njihove
      elektronske naslove obveščamo o naših storitvah in vsebinah. Pri tem ne
      uporabljamo nikakršnega (avtomatskega) profiliranja, temveč vam zgolj
      pošiljamo osnovno prilagojena sporočila, za katere ocenimo, da bi vas
      utegnila zanimati na podlagi vaših preteklih interakcij z nami. Obdelavi
      vaših kontaktnih podatkov za namen takega neposrednega oglaševanja lahko
      kadarkoli ugovarjate, tako da nam pošljete elektronsko sporočilo na
      elektronski naslov: mitja.krajnc@expar-store.com. Dodatne informacije o vaših pravicah
      v zvezi z neposrednim trženjem so vam na voljo v poglavju »Vaše pravice«.
    </p>
    <h2>Pošiljanje povpraševanja in ostala komunikacija z nami</h2>
    <p>
      Ko na naše kontaktne podatke (naslov, elektronski naslov, telefonska
      številka), objavljene na naših spletnih straneh, pošljete povpraševanje po
      določeni storitvi, vaše osebne podatke obdelujemo izključno za namene
      priprave odgovora na vaše povpraševanje, da vas obvestimo, ali je
      storitev, po katerem povprašujete, na voljo, za morebitno pripravo in
      sklenitev pogodbe, za izvajanje sklenjene pogodbe ter da vam odgovorimo na
      vaše vprašanje. <br /><br />
      V ta namen zbiramo zgolj tiste vaše osebne podatke, ki nam jih posredujete
      na prostovoljen način. Vsi podatki, ki so zbrani preko naših spletnih
      strani ali so nam kako drugače sporočeni (npr. s pomočjo
      telekomunikacijskih sredstev), se zbirajo z namenom zagotavljanja storitev
      spletne strani expar-store.com ter za namen naše interne administracije
      in vodenja našega poslovanja. <br /><br />
      Posredovane kontaktne podatke lahko na podlagi našega zakonitega interesa
      obdelujemo tudi za osnovno prilagojeno komuniciranje z vami preko
      elektronske pošte in vam skušamo predstaviti ustrezne izdelke, ki bi vam
      bili lahko zanimivi na podlagi vaših preteklih interakcij z nami. Pri tem
      ne uporabljamo nikakršnega (avtomatskega) profiliranja, temveč zgolj
      izbiramo ustrezne nabore prejemnikov za posamezna sporočila. Od tovrstnega
      komuniciranja se lahko kadarkoli brezplačno odjavite na način, da nam
      pošljete elektronsko sporočilo na elektronski naslov: mitja.krajnc@expar-store.com.
      Dodatne informacije o vaših pravicah v zvezi z neposrednim trženjem so vam
      na voljo v poglavju »Vaše pravice«.
    </p>
    <h2>Piškotki</h2>
    <h3>NA SPLOŠNO</h3>
    <p>
      Piškotek je majhna datoteka, ki se shrani na računalniku ob obisku spletne
      strani. Piškotki vsebujejo različne informacije, ki jih spletna stran
      prebere, ko jo ponovno obiščete. Uporablja jih večina sodobnih spletnih
      strani. Sami po sebi piškotki niso škodljivi, ne vsebujejo virusov ali
      kakšne drugačne zlonamerne kode. Uporabljajo se za različne namene, za
      seje (npr. prijavljanje v uporabniški račun), za košarice v spletnih
      trgovinah, za prikaz različnih naprednih vsebin na spletni strani(npr.
      zemljevidi, video), za vodenje statistike obiska strani, za podporo
      vtičnikom družabnih omrežij, ter tudi za prikazovanje oglasov po meri
      uporabnika spleta.

      <br /><br />Zakonsko omejevanje piškotkov je predvsem posledica zlorabe
      tehnologije piškotkov za sledenje uporabnikom in s tem poseganja v
      zasebnost na spletu.
    </p>
    <h3>VRSTE PIŠKOTKOV</h3>
    <p>
      Začasni ali sejni piškotki (session cookies) »živijo« od trenutka, ko
      uporabnik odpre brskalnik, pa do trenutka, ko sejo konča in zapre
      brskalnik. Spletna mesta jih uporabljajo za shranjevanje začasnih
      informacij, na primer elementov v nakupovalnem vozičku, za večjo varnost
      pri spletnem bančništvu, itd. Ker so taki piškotki shranjeni za krajši
      čas, je njihova invazivnost za zasebnost uporabnika lahko manjša.
      <br /><br />Trajni ali shranjeni piškotki (persistent cookies) pa ostanejo
      shranjeni, tudi ko uporabnik zapre brskalnik in zaključi sejo. Spletna
      mesta jih uporabljajo npr. za shranjevanje informacij o registraciji,
      nastavitvah jezika strani, itd., pa tudi za grajenje profilov uporabnikov
      in analiziranje prometa. Trajni piškotki lahko v računalniku ostanejo več
      dni, mesecev ali celo let. <br /><br />Lastni piškotki (1st party cookies)
      so s spletnega mesta, ki si ga uporabnik ogleduje, in so lahko trajni ali
      začasni. Spletna mesta te piškotke uporabljajo za shranjevanje informacij,
      ki jih bodo znova uporabila, ko uporabnik naslednjič obišče to mesto.
      <br /><br />Drugi piškotki (3rd party cookies) izvirajo od drugih,
      partnerskih spletnih mest (ki na primer prikazujejo oglase na izvirni
      spleteni strani ali merijo promet). Tretje strani lahko na ta način
      zbirajo podatke o uporabnikih iz različnih spletnih mest in jih
      uporabljajo za različne namene, od oglaševanja, analitike pa do izboljšave
      svojih produktov. Taki piškotki predstavljajo večji poseg v zasebnost
      uporabnika.<br /><br />
      Zavezujemo se, da pri nameščanju piškotkov upoštevamo relevantno
      zakonodajo, zlasti pa, določila Zakona o elektronskih komunikacijah,
      Splošne uredbe o varstvu podatkov in vsakokratnega zakona o varstvu
      podatkov.
    </p>
    <h3>KATERE PODATKE ZBIRAMO Z UPORABO PIŠKOTKOV?</h3>
    <p>
      Z uporabo piškotkov zbiramo naslednje podatke obiskovalcev naših spletnih
      strani:
    </p>
    <ul>
      <li>informacije o napravi (vrsta, znamka in tip),</li>
      <li>informacije o operacijskem sistemu (vrsta in verzija),</li>
      <li>informacije o spletnem brskalniku (vrsta in verzija),</li>
      <li>informacije o nastavitvah zaslona (npr. resolucija),</li>
      <li>informacije o straneh, ki so bile prikazane.</li>
    </ul>
    <p>
      Tehnične informacije o napravi in programski opremi zbiramo zaradi
      zagotavljanja kakovostnega prikaza spletnih strani naše trgovine.
      Informacije o straneh, ki so bile prikazane, zbiramo za potrebe analize,
      ki nam omogočajo izboljševanje vsebin in uporabniške izkušnje.
      <br /><br />
      Če se uporabnik naše spletne trgovine registrira oziroma prijavi, pa lahko
      z uporabo piškotkov od njega zbiramo tudi nekatere osebne podatke:
    </p>
    <ul>
      <li>IP naslov,</li>
      <li>podatke o lokaciji oziroma vstopni točki dostopa do interneta,</li>
      <li>podatke o elektronskem naslovu in geslu,</li>
      <li>vnose v spletne obrazce,</li>
      <li>vnose v nakupovalno košarico.</li>
    </ul>
    <p>
      Te podatke potrebujemo zaradi potrebe avtentikacije uporabnikov naše
      spletne trgovine, in sicer da se lahko prepričamo, da je prijavo izvedel
      registriran oziroma prijavljen uporabnik. Nadalje te podatke potrebujemo
      za to, da si spletno mesto zapolni uporabnikov vnos v spletne obrazce in
      nakupovalno košarico. Prav tako pa te podatke uporabljamo za vodenje
      statistike in za izvajanje marketinških aktivnosti.
    </p>
    <h3>VRSTE PIŠKOTKOV, KI JIH UPORABLJAMO NA WWW.SVETINA-RANCH.SI</h3>
    <h4>LASTNI IN NUJNO POTREBNI PIŠKOTKI:</h4>
    <p>
      Lastne sejne ali trajne piškotke uporabljamo za to, da si spletno mesto
      zapomni uporabnikove vnose v spletne obrazce, nakupovalno košarico, za
      prilagoditev nastavitev uporabnikovim željam, kot je način razvrščanja
      rezultatov/vsebine, ipd. <br /><br />
      V tem primeru uporabnik aktivno vpisuje vsebino, oziroma jasno izrazi
      željo s tem, da klikne na gumb »dodaj v košarico« , recimo razvrsti
      izdelke v kategoriji po določeni lastnosti, ali podobno. Taki piškotki so
      nujno potrebni, da vam ponudimo storitve, ki so na voljo na tej spletni
      strani. Omogočajo, da si stran zapomni in izvede uporabnikovo zahtevo kot
      je npr. prijava v uporabniški profil ali vsebina nakupovalne košarice.
      <br /><br />
      Lastni sejni piškotki iz spletnega mesta www.expar-store.com trajajo le
      čas ene seje, torej od trenutka ko vstopite na spletno mesto, do trenutka
      ko ga zaprete. Teh piškotkov ni mogoče drugače odstraniti, razen z
      neobiskovanjem tega spletnega mesta. <br /><br />
      Osebni lastni piškotki, ki lahko trajajo do 10 let omogočajo, pravilno
      prikazovanje obrazcev kot sta obrazec za potrditev piškotkov ter še bolj
      pomembno, da si zapomnijo vašo odločitev glede uporabe piškotkov na naši
      spletni strani. Tudi ti piškotki so nujno potrebni.
    </p>
    <table>
      <thead>
        <th>Ime piškotka</th>
        <th>Namen piškotka</th>
        <th>Čas trajanja</th>
      </thead>
      <tbody>
        <tr>
          <td>mp_ga</td>
          <td>sistemski piškotek</td>
          <td>Trajanje: do 10 let</td>
        </tr>
        <tr>
          <td>teak-cart</td>
          <td>sistemski piškotek</td>
          <td>Trajanje: do 1 mesec</td>
        </tr>
        <tr>
          <td>mp_acookie</td>
          <td>sistemski piškotek</td>
          <td>Trajanje: do 10 let</td>
        </tr>
        <tr>
          <td>popover-dan</td>
          <td>sistemski piškotek</td>
          <td>Trajanje: do 1 dan</td>
        </tr>
        <tr>
          <td>mp_currentlang</td>
          <td>sistemski piškotek</td>
          <td>Trajanje: do 1 mesec</td>
        </tr>
        <tr>
          <td>5a3deac1009db2c066ac1acaf08b8941</td>
          <td>sistemski piškotek</td>
          <td>Na sejo</td>
        </tr>
      </tbody>
    </table>
    <h4>
      DRUGI PIŠKOTKI KOT SO PIŠKOTKI DRUŽABNIH OMEREŽIJ, PIŠKOTKI ZA ANALITIKO
      TER PIŠKOTKI ZA OGLAŠEVALSKE AKTIVNOSTI:
    </h4>
    <p>
      Druge piškotke uporabljamo za to, da nam pomagajo pri optimizaciji naše
      spletne strani in izboljšavah njene funkcionalnosti. Te piškotke
      uporabljamo le, če ste z njihovo namestitvijo soglašali.
    </p>
    <h4>GOOGLE ANALYTICS PIŠKOTKI:</h4>
    <p>
      Naša spletna stran se konstantno razvija in prilagaja željam uporabnikov
      tudi zaradi storitev in sejnih ter trajnih piškotkov Google Analytics, ki
      omogočajo poglobljen pogled v uporabniško izkušnjo in nam pomagajo pri
      optimizaciji spletne strani. <br /><br />Podatki o uporabi spletnega mesta
      (standardni internetni dnevniški podatki (vključno z vašim naslovom IP) in
      podatki o vedenju obiskovalcev v anonimni obliki), ki jih vsebujejo
      piškotki, se prenesejo in shranijo pri podjetju Google, tudi na strežnikih
      v Združenih državah. Preden vaš naslov IP pošljemo podjetju Google, ga
      anonimiziramo. Podjetje Google v skladu s potrdilom o zasebnostnem ščitu
      izjavlja, da spoštuje okvir zasebnostnega ščita, sklenjen med EU in ZDA. V
      skladu s pogoji uporabe Google Analytics podjetje Google naslova IP
      posameznika, na katerega se nanašajo osebni podatki, ne bo povezalo z
      nobenimi drugimi podatki, ki jih ima Google in torej teh podatkov ne bo
      uporabljalo za lastne namene. <br /><br />Se morda sprašujete, zakaj ste
      so se vam Google Analytics piškotki naložili brez vaše eksplicitne
      privolitve? Ker Google Analytics z naše spletne strani pridobi
      anonimizirane podatke, se Google Analytics piškotki smatrajo kot manj
      invazivni, saj ne zbirajo osebnih podatkov in se lahko namestijo na
      podlagi t.i. domnevne privolitve.
    </p>
    <h4>GOOGLE PIŠKOTKI:</h4>
    <p>
      Sejne in trajne piškotke Google uporablja za mnoge funkcionalnosti, kamor
      štejemo shranjevanje priljubljenih uporabniških nastavitev, prikazovanje
      Google zemljevidov in njihovih funkcionalnosti, prikazovanje oglasov po
      meri uporabnikom, uskladitev prikazov oglasov na različnih napravah in
      njihove meritve, itd.
    </p>
    <table class="table">
      <thead>
        <th>Ime piškotka</th>
        <th>Namen piškotka</th>
        <th>Čas trajanja</th>
      </thead>
      <tbody>
        <tr>
          <td>1P_JAR</td>
          <td>Google piškotek</td>
          <td>Trajanje: do 1 mesec</td>
        </tr>
        <tr>
          <td>AID</td>
          <td>Google piškotek</td>
          <td>Trajanje: do 2 leti</td>
        </tr>
        <tr>
          <td>APISID</td>
          <td>Google piškotek</td>
          <td>Trajanje: do 2 leti</td>
        </tr>
        <tr>
          <td>CONSENT</td>
          <td>Google piškotek</td>
          <td>Trajanje: do 20 let</td>
        </tr>
        <tr>
          <td>HSID</td>
          <td>Google piškotek</td>
          <td>Trajanje: do 2 leti</td>
        </tr>
        <tr>
          <td>NID</td>
          <td>Google piškotek</td>
          <td>Trajanje: do 6 mesecev</td>
        </tr>
        <tr>
          <td>SAPISID</td>
          <td>Google piškotek</td>
          <td>Trajanje: do 2 leti</td>
        </tr>
        <tr>
          <td>SID</td>
          <td>Google piškotek</td>
          <td>Trajanje: do 2 leti</td>
        </tr>
        <tr>
          <td>SSID</td>
          <td>Google piškotek</td>
          <td>Trajanje: do 2 leti</td>
        </tr>
        <tr>
          <td>SIDCC</td>
          <td>Google piškotek</td>
          <td>Trajanje: do 6 mesecev</td>
        </tr>
        <tr>
          <td>OGPC</td>
          <td>Google piškotek</td>
          <td>Trajanje: do 6 mesecev</td>
        </tr>
        <tr>
          <td>_gmb_ga_test</td>
          <td>Google piškotek</td>
          <td>Trajanje: do 1 leto</td>
        </tr>
        <tr>
          <td>OTZ</td>
          <td>Google piškotek</td>
          <td>Trajanje: do 1 mesec</td>
        </tr>
        <tr>
          <td>_gcl_au</td>
          <td>Google piškotek</td>
          <td>Trajanje: do 6 mesecev</td>
        </tr>
        <tr>
          <td>_ga</td>
          <td>Google piškotek</td>
          <td>Trajanje: do 2 leti</td>
        </tr>
        <tr>
          <td>S</td>
          <td>Google piškotek</td>
          <td>Na sejo</td>
        </tr>
      </tbody>
    </table>
    <h4>FACEBOOK PIŠKOTKI:</h4>
    <p>
      Sejni in trajni piškotki Facebook spletne strani omogočajo prijazno
      izkušnjo skupne rabe, kajti omogočajo preprosto interakcijo preko
      družabnih omrežij in beležijo metrike kot so število delitev, všečkov,
      komentarjev in ustvarjanje oglasov po meri uporabnikov.
    </p>
    <table class="table">
      <thead>
        <th>Ime piškotka</th>
        <th>Namen piškotka</th>
        <th>Čas trajanja</th>
      </thead>
      <tbody>
        <tr>
          <td>FR</td>
          <td>Facebook piškotek</td>
          <td>Trajanje: do 6 mesecev</td>
        </tr>
      </tbody>
    </table>
    <h4>
      NENUJNE PIŠKOTKE LAHKO ENOSTAVNO ODSTRANITE, ČE SLEDITE NAVODILOM NA
      SPODNJIH POVEZAVAH:
    </h4>
    <p>
      Brskalnik GOOGLE CHROME:
      <a
        target="_blank"
        href="https://support.google.com/chrome/answer/95647?hl=sl"
        >Preberi NAVODILA >></a
      >
    </p>
    <p>
      Brskalnik MOZILLA FIREFOX:
      <a
        target="_blank"
        href="https://support.mozilla.org/sl/kb/izbrisite-piskotke-podatke-strani?redirectlocale=sl&redirectslug=izbrisite-piskotke"
        >Preberi NAVODILA >></a
      >
    </p>
    <p>
      Brskalnik INTERNET EXPLORER:
      <a
        target="_blank"
        href="https://support.microsoft.com/sl-si/help/17442/windows-internet-explorer-delete-manage-cookies"
        >Preberi NAVODILA >></a
      >
    </p>
    <p>
      Brskalnik OPERA:
      <a
        target="_blank"
        href="https://help.opera.com/en/latest/web-preferences/"
        >Preberi NAVODILA >></a
      >
    </p>
    <p>
      Brskalnik SAFARI:
      <a target="_blank" href="https://support.apple.com/safari"
        >Preberi NAVODILA >></a
      >
    </p>
    <h2>Uporabniki podatkov</h2>
    <p>
      Zavezujemo se, da vaših osebnih podatkov ne bomo posredovali tretjim
      nepooblaščenim osebam brez vaše privolitve. <br /><br />Seznanjamo vas, da
      lahko posamezna opravila v zvezi z vašimi podatki zaupamo našim poslovnim
      partnerjem (pogodbenim obdelovalcem). Pogodbeni obdelovalci lahko zaupane
      podatke obdelujejo izključno v našem imenu in v mejah našega pooblastila
      (v pisni pogodbi oziroma drugem pravnem aktu) ter skladno z nameni, ki so
      opredeljeni v tej Izjavi. Posredovane podatke omenjeni partnerji skrbno
      varujejo in ne hranijo na zalogo, ter jih ne uporabljajo za lastne namene.
      <br /><br />
      V okviru zakonskih pristojnosti se vaši osebnih podatki lahko razkrivajo
      naslednjim uporabnikom podatkov:
    </p>
    <ul>
      <li>
        izvajalcem turističnih storitev, kot so hotelirji, organizatorji
        potovanj, ponudnikom najemov opreme oz. vozil, prevozniki, vodniki in
        podobno;
      </li>
      <li>
        rezervacijskim sistemom GDS (Global Distribution System), preko katerih
        rezerviramo turistične storitve (hotele, rent a car, transferje, izlete
        in podobno);
      </li>
      <li>
        zavarovalnicam - ponudnicam turističnih zavarovanj bodisi za odpoved
        potovanja, nezgodno zavarovanje ali zdravstveno zavarovanje z asistenco
        za katero ste se vi odločili ob ali po opravljeni rezervaciji (npr.
        Triglav, Grawe, Coris, Europäische ...);
      </li>
      <li>
        podjetjem s kreditnimi in debetnimi karticami, ki nam olajšajo plačila
        in preverjanje proti goljufijam, ki morda potrebujejo informacije o
        načinu plačila in rezervaciji turistične storitve za obdelavo plačila
        ali zagotovitev varnosti vaše plačilne transakcije;
      </li>
      <li>
        v okviru nagradnih iger posredujemo vaše podatke ustreznim partnerjem
        nagradne igre, če je tako navedeno v Splošnih pravilih nagradne igre.
      </li>
      <li>
        Družabni mediji: morda boste lahko dostopali do spletnih storitev
        tretjih oseb prek naše spletne strani ali aplikacije ali pred prihodom
        na našo spletno stran ali aplikacijo. Ko ste registrirani pri svojem
        računu za socialne storitve, bomo pridobili osebne podatke, ki jih
        nameravate deliti z nami prek teh družbenih medijskih storitev v skladu
        z nastavitvami zasebnosti, da bi izboljšali in prilagodili vašo uporabo
        naše spletne strani ali aplikacije. Na naši spletni strani ali
        aplikaciji lahko uporabimo tudi vtičnike za socialne medije. Kot
        rezultat bodo vaše informacije dane v skupno rabo s svojim ponudnikom
        socialnih medijev in morda predstavljene v vašem profilu družabnih
        omrežij, ki jih želite dati v skupno rabo z drugimi v vašem omrežju. Če
        želite izvedeti več o teh postopkih, si oglejte pravilnik o zasebnosti
        teh ponudnikov socialnih medijev tretjih oseb.
      </li>
      <li>
        ponudnikom poštnih storitev, ponudnikom odpremnih storitev in
        logistično/dostavni službi za namen izvršitve vašega naročila;
      </li>
      <li>
        računovodskemu servisu, odvetniškim pisarnam in drugim ponudnikom
        pravnega in poslovnega svetovanja;
      </li>
      <li>ponudnikom storitev uničenja spisov in nosilcev podatkov;</li>
      <li>
        ponudnikom storitev informacijske tehnologije v okviru servisiranja in
        vzdrževanja programske opreme;
      </li>
      <li>administratorju in skrbniku spletne strani;</li>
      <li>
        ponudnikom storitev računalništva v oblaku in ponudnikom pošiljanja
        e-poštnih sporočil (npr. SqualoMail, Mailchimp in drugi);
      </li>
      <li>ponudnikom sistemov za upravljanje odnosov s strankami.</li>
    </ul>
    <p>
      Zavezujemo se, da niti mi niti drugi uporabniki, vaših osebnih podatkov ne
      bodo posredovali ali prenesli v tretjo državo izven Evropske unije in/ali
      Evropskega gospodarskega prostora ali v mednarodno organizacijo brez
      ustrezne stopnje zaščite. Vaši osebni podatki se lahko posredujejo v ZDA,
      pri čemer so vsi naši pogodbeni obdelovalci v ZDA vključeni v program
      zasebnostnega ščita EU-ZDA (t.i. Privacy Shield) ali pa v primeru prenosa
      podatkov zagotavljajo druge ustrezne zaščitne ukrepe skladno z določbo 46.
      člena Splošne uredbe o varstvu podatkov (npr. sprejem Standardnih
      pogodbenih klavzul).
    </p>
    <p2>Povezave do drugih spletnih strani </p2>
    <p>
      Naša ponudba na spletu vsebuje povezave do drugih spletnih strani. Ta
      izjava o varovanju podatkov ne velja za druge ponudnike. Ker nimamo vpliva
      na to, ali njihovi upravljavci spoštujejo določbe o varovanju podatkov,
      tudi ne prevzemamo odgovornosti za pravilnost, ažurnost in popolnost
      informacij, ki jih zagotavljajo na svojih straneh. Svetujemo vam, da si
      preberete njihovo politiko varovanja podatkov, saj je lahko njihova
      politika drugačna od naše.
    </p>
    <h2>Obdobje hrambe osebnih podatkov</h2>
    <p>
      Zagotavljamo vam, da vaše podatke hranimo le toliko časa, kolikor je
      potrebno, da se izpolni namen, zaradi katerega so bili posamezni podatki
      zbrani in nadalje uporabljeni. Po preteku obdobja hrambe bomo vaše osebne
      podatke učinkovito in trajno izbrisali ali anonimizirali, tako da vaša
      identifikacija ne bo več mogoča. <br /><br />
      Tiste podatke, ki obdelujemo na podlagi zakona, hranimo za obdobje, ki ga
      predpisuje zakon. Podatke, ki jih obdelujemo zaradi izvedbe pogodbenega
      odnosa z vami, hranimo za obdobje, ki je potrebno za izvršitev pogodbe in
      še ves čas, ko traja zakonski zastaralni rok za zahtevke iz tako sklenjene
      pogodbe, razen v primeru spora v zvezi s pogodbenim razmerjem.
      <br /><br />
      Osebne podatke, ki jih obdelujemo na podlagi vaše privolitve ali
      zakonitega interesa, npr. v primeru pošiljanje elektronskih novic, hranimo
      trajno do preklica te privolitve z vaše strani oziroma do zahteve po
      prekinitvi obdelave, pri čemer se zavezujemo, da bomo obstoj namena
      obdelave osebnih podatkov preverjali na redne časovne intervale. Podatke
      bomo pred preklicem izbrisali le, če je že dosežen namen obdelave osebnih
      podatkov (npr. če bi prenehali pošiljati oglasna elektronska sporočila)
      ali če tako določa zakon. <br /><br />
      Če za določene podatke, ki se obdelujejo za realizacijo pogodb, obstaja
      drugačen zakonski rok shranjevanja (npr. računovodski ali davčni podatki),
      znaša rok hrambe do 10 let. V tem času je obdelava podatkov omejena.
    </p>
    <h2>Varnost vaših podatkov</h2>
    <p>
      Vaše podatke, ki nam jih posredujete z uporabo naših spletnih strani, po
      telekomunikacijskih kanalih ali na kakršenkoli drug način, skrbno varujemo
      pred izgubo, zlorabo, nepooblaščenim dostopom ali razkrivanjem,
      spreminjanjem ali uničenjem. <br /><br />Podatki so shranjeni v strežnikih
      zaščitenih s geslom in z omejenim dostopom. Spletna stran
      expar-store.com dobro skrbi za varnost vaših osebnih podatkov in
      spoštuje vaše izbire za njihovo nameravano rabo.<br /><br />
      Po prenehanju potrebe po vodenju podatkov, tj. po izpolnitvi namena, za
      katerega so bili podatki zbrani, se podatki nemudoma nepovratno in trajno
      izbrišejo. <br /><br />V primeru, da so na spletnem mestu
      expar-store.com objavljene povezave na druge spletne strani, ki niso v
      nikakršni povezavi z Hriberšek Mitja Krajnc s.p., ne prevzemamo nobene odgovornosti za
      zaščito vaših podatkov na teh spletnih straneh.
    </p>
    <h2>Svoboda izbire</h2>
    <p>
      Informacije, ki nam jih posredujete, nadzorujete vi. Če se odločite, da
      nam določenih podatkov ne boste posredovali, potem do nekaterih mest
      oziroma funkcij na naših spletnih straneh ne boste mogli dostopati, prav
      tako vam v takih primerih ne bomo mogli odgovoriti na vaše povpraševanje
      ali z vami skleniti pogodbenega razmerja ter vam posledično prodati in
      dostaviti želenih izdelkov. <br /><br />Če obvestil o novicah po
      elektronski pošti ne želite več prejemati, se lahko od prejemanja novic
      brezplačno odjavite, tako da nam pošljete elektronsko sporočilo z vsebino
      "Odjava od elektronskih novic" ali drugo podobno vsebino na elektronski
      naslov: mitja.krajnc@expar-store.com. Če se spremenijo vaši osebni podatki (poštna
      številka, elektronski naslov, naslov, telefonska številka idr.), vas
      prosimo, da nas o spremembah obvestite na elektronski naslov:
      etn@turnsek.si.
    </p>
    <h2>Privolitev otrok</h2>
    <p>
      Otroci do 15 let nam lahko posredujejo osebne podatke preko naših spletnih
      strani ali drugače samo z dovoljenjem (privolitev ali odobritev) nosilca
      starševske odgovornosti za otroka (enega od staršev ali skrbnikov).<br /><br />
      Zavezujemo se, da ne bomo nikoli zavestno zbirali osebnih podatkov od
      oseb, za katere bi bili seznanjeni, da so mlajše od 15 let. Teh podatkov
      ne bomo uporabili ali razkrili tretji nepooblaščeni stranki brez
      dovoljenja nosilca starševske odgovornosti za otroka. Navedeno pa ne
      vpliva na pravila slovenskega pogodbenega prava v zvezi s pravili o
      veljavnosti, oblikovanju ali učinku pogodbe v zvezi z otrokom.
      <br />Upravljavec si bo ob upoštevanju razpoložljive tehnologije v takih
      primerih razumno prizadeval za preveritev, ali je nosilec starševske
      odgovornosti za otroka dal ali odobril privolitev.
    </p>
    <h2>Vaše pravice</h2>
    <p>
      ETN zagotavlja uresničevanje vseh vaših pravic, ki vam pripadajo v zvezi z
      obdelavo vaših osebnih podatkov na podlagi veljavnih pravnih predpisov.
      <br /><br />Kot posamezniki imate naslednje pravice: <br /><br />
      <b>Pravica do preklica privolitve:</b> Če ste kot posameznik privolili v
      obdelavo vaših osebnih podatkov (v enega ali več določenih namenov), imate
      pravico do preklica privolitve. Preklic privolitve ne vpliva na zakonitost
      obdelave podatkov, ki se je izvajala do njenega preklica. <br /><br />
      Vašo privolitev lahko kadarkoli brezplačno prekličete s pisno izjavo, ki
      se pošlje upravljavcu na elektronski naslov: etn@turnsek.si. Preklic
      privolitve za obdelavo vaših osebnih podatkov nima nobenih negativnih
      posledic ali sankcij. <br /><br />
      <b>Pravica dostopa do osebnih podatkov:</b> Kot posameznik imate od
      upravljavca pravico dobiti potrditev, ali se podatki v zvezi z vami
      obdelujejo ali ne. Če je temu tako, imate pravico, da vam omogočimo dostop
      do vaših osebnih podatkov (tj. vpogled ter njihovo prepisovanje ali
      kopiranje) ter da vam podamo informacije v zvezi z obdelavo vaših osebnih
      podatkov (npr. o namenu obdelave, vrsti osebnih podatkov, uporabnikih,
      katerim so bili ali jim bodo posredovani osebni podatki, predvidenem
      obdobju hrambe podatkov, o tehničnih in organizacijskih ukrepih za
      varovanje podatkov, obstoju avtomatiziranega sprejemanja odločitev,
      vključno z oblikovanjem profilov idr.),<br /><br />
      <b>Pravica do popravka:</b> Kot posameznik imate pravico doseči, da vam
      omogočimo popravek netočnih osebnih podatkov v zvezi z vami in da vam
      omogočimo dopolnitev nepopolnih osebnih podatkov. V ta namen imate
      pravico, da nam posredujete dopolnilno izjavo z ažurnimi osebnimi podatki.
      <br /><br />
      <b>Pravica do izbrisa osebnih podatkov (t.i. pravica do pozabe):</b>
      Pravico imate doseči, da upravljavec brez nepotrebnega odlašanja izbriše
      osebne podatke v zvezi z vami, če obstaja eden izmed razlogov iz 17. člena
      Splošne uredbe o varstvu podatkov (npr. če podatki niso več potrebni v
      namene, za katere so bili zbrani ali kako drugače obdelani, če prekličete
      privolitev in za obdelavo in ne obstaja nobena druga pravna podlaga, če
      ugovarjate obdelavi, pa ne obstajajo prevladujoči zakoniti interesi, če so
      bili osebni podatki obdelani nezakonito idr.). <br /><br />
      <b>Pravica do omejitve obdelave:</b> Pravico imate doseči, da upravljavec
      omeji obdelavo vaših podatkov, če obstaja en od naslednjih primerov:
      <br /><br />
    </p>
    <ul>
      <li>
        če oporekate točnosti obdelave podatkov, za obdobje, ki upravljavcu
        omogoča preveriti točnost podatkov;
      </li>
      <li>
        če je obdelava nezakonita, vi pa namesto izbrisa zahtevate omejitev
        obdelave,
      </li>
      <li>
        če upravljavec podatkov ne potrebuje več, potrebujete pa jih vi za
        uveljavljanje, izvajanje ali obrambo pravnih zahtevkov;
      </li>
      <li>
        če ste vložili ugovor v zvezi z obdelavo, dokler se ne preveri, ali
        zakoniti razlogi upravljavca prevladajo nad vašimi razlogi
      </li>
    </ul>
    <br /><br />
    <p>
      <b>Pravica do prenosljivosti podatkov:</b> Kot posameznik imate pravico,
      da prejmete vaše osebne podatke v splošno uporabljeni in strojno berljivi
      obliki ter da te podatke neposredno posredujemo drugemu upravljavcu, pri
      čemer to velja le v primeru, če obdelava vaših osebnih podatkov temelji na
      podlagi privolitve ali pogodbenega razmerja in se obdelava izvaja z
      avtomatiziranimi sredstvi.<br /><br />
      <b>Pravica do ugovora:</b> Če obdelava podatkov temelji na naših zakonitih
      interesih, imate na podlagi razlogov, povezanih z vašim posebnim
      položajem, pravico, da kadarkoli ugovarjate obdelavi vaših osebnih
      podatkov. V takem primeru bomo nadaljevali z obdelavo vaših osebnih
      podatkov le v primeru, če bomo dokazali nujne legitimne razloge za
      obdelavo, ki bodo prevladali nad vašimi interesi, pravicami in
      svoboščinami, ali za uveljavljanje, izvajanje ali obrambo pravnih
      zahtevkov. <br /><br />
      Obdelavi vaših osebnih podatkov za namene neposrednega trženja, vključno z
      oblikovanjem profilov, lahko kadarkoli in brezplačno ugovarjate brez
      navedbe razlogov, tako da nam pošljete sporočilo na elektronski naslov:
      mitja.krajnc@expar-store.com. Če ugovarjate obdelavi vaših podatkov za namene
      neposrednega trženja, bomo nemudoma prenehali obdelovati vaše podatke za
      te namene. <br /><br />
      Prav tako vam bomo na vašo zahtevo v skladu z veljavno zakonodajo podali
      tudi druge informacije v zvezi z vašimi osebnimi podatki, ki jih
      obdelujemo. <br /><br />
      <b>Pravica do vložitve pritožbe:</b> Če sumite, da pri obdelavi vaših
      podatkov prihaja do kršitev zakonodaje s področja varstva osebnih
      podatkov, imate pravico vložiti pritožbo pri Informacijskem pooblaščencu
      Republike Slovenije, na naslovu Zaloška 59, 1000 Ljubljana, Slovenija,
      telefonska številka: 00 386 (0)1 230 97 30, elektronski naslov:
      gp.ip@ip-rs.si.
    </p>
    <h2>Stik</h2>
    <p>
      Na vprašanja o zaupnosti vaših podatkov, načinu zbiranja in obdelave
      podatkov ali na vaše zahteve za uveljavljanje pravic v zvezi z vašimi
      podatki, vam bo odgovorila odgovorna oseba pri Hriberšek Mitja Krajnc s.p. na telefonski
      številki: +386 41 763 005 ali na elektronskem naslovu: mitja.krajnc@expar-store.com.
      <br /><br />Zavezujemo se, da bomo na vaše zahteve odgovorili brez
      nepotrebnega odlašanja, najkasneje pa v zakonsko predpisanih rokih.<br /><br />
      Za potrebe zanesljive identifikacije v primeru uveljavljanja pravic v
      zvezi z osebnimi podatki, lahko od vas zahtevamo dodatne podatke. Če vas
      kljub temu ne bomo mogli zanesljivo identificirati, bomo morali na žalost
      vašo zahtevo zavrniti.
    </p>
    <h2>Spremembe</h2>
    <p>
      Pridržujemo si pravico, da predmetno Izjavo po potrebi občasno prilagodimo
      dejanskim razmeram in zakonodaji s področja varstva osebnih podatkov. Iz
      tega razloga vas prosimo, da pred vsakim posredovanjem osebnih podatkov
      preverite aktualno različico, da boste seznanjeni z morebitnimi
      spremembami in dopolnitvami. <br /><br />Prav tako vas bomo o morebitnih
      spremembah, ki bistveno vplivajo na obdelavo vaših osebnih podatkov,
      predhodno obvestili na primeren način (npr. z obvestilom na naši spletni
      strani, po elektronski pošti).
    </p>
    <br />
    <br />
    <p>
      Verzija: 1.0 <br />
      Posodobljeno: 24. 11. 2021
    </p>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: this.$i18n.t('PrivacyPolicy'),
    }
  },
  nuxtI18n: {
    paths: {
      sl: "/politika-zasebnosti", // -> mydomain.com/en/politika-zasebnosti
      en: "/privacy-policy", // -> mydomain.com/en/privacy-policy
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: 3em;
  line-height: 1.5em;
  margin: 1em;
}
h2 {
  font-size: 2.4em;
  font-weight: 600;
  line-height: 1em;
  margin: 0.5em;
}
h3 {
  font-size: 1.7em;
  line-height: 0.8em;
  margin: 0.4em;
}
h4 {
  font-size: 1.4em;
  line-height: 0.6em;
  margin-top: 1.5em;
}
p {
  font-size: 1.3em;
  line-height: 1.5em;
  text-align: justify;
  margin-left: 10em;
  margin-right: 10em;
}
li {
  font-size: 1.3em;
  line-height: 1.5em;
  text-align: left;
  margin-left: 20em;
  margin-right: 10em;
  list-style-type: square;
}

th {
  font-size: 1.3em;
  line-height: 1.5em;
  text-align: left;
}
td {
  font-size: 0.6em;
  line-height: 1.5em;
  text-align: left;
}
table {
  margin-left: 15em;
}

@media screen and (max-width: 680px) {
  .privacy {
    margin: 0;
  }
  h1 {
    font-size: 2.5em;
    line-height: 1em;
    margin: 1em;
  }
  h2 {
    font-size: 1.7em;
    font-weight: 600;
    line-height: 1.2em;
    margin: 0.4em;
  }
  h3 {
    font-size: 1.6em;
    line-height: 1.2em;
    margin: 0.4em;
  }
  h4 {
    font-size: 1.4em;
    line-height: 1em;
    margin-top: 1.5em;
  }
  p {
    font-size: 1em;
    line-height: 1.5em;
    text-align: justify;
    margin: 20px;
    word-wrap: break-word;
  }
  li {
    font-size: 1em;
    line-height: 1.5em;
    text-align: left;
    margin-left: 3em;
    margin-right: 1em;
    list-style-type: square;
  }

  th {
    font-size: 1em;
    line-height: 1em;
    text-align: left;
    padding-bottom: 1.5em;
  }
  td {
    font-size: 0.65em;
    line-height: 1.6em;
    text-align: left;
    padding-bottom: 1.5em;
  }
  table {
    margin: 1em;
  }
}
</style>
